import { render } from "./InterFooter.vue?vue&type=template&id=e7668ca2&scoped=true"
import script from "./InterFooter.vue?vue&type=script&lang=js"
export * from "./InterFooter.vue?vue&type=script&lang=js"

import "./InterFooter.vue?vue&type=style&index=0&id=e7668ca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7668ca2"]])

export default __exports__